import { useState } from "react";
import { Button, ChevronDown, Trash2 } from "@repo/ui";
import { cn } from "@repo/utils";
import { BrandPaths } from "./brand-paths";
import { useDeleteBrand } from "./use-delete-brand";
import type { BrandSettingsDTO } from "../brand-settings-page";

type Props = {
  brand: BrandSettingsDTO;
  hasActiveTasks: boolean;
};

export const Brand = ({ brand, hasActiveTasks }: Props) => {
  const { deleteBrand } = useDeleteBrand();
  const [expanded, setExpanded] = useState(false);
  return (
    <div className="card-border flex flex-col px-5 py-3.5">
      <div className="flex justify-between">
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-7">
            {/* // TODO: fix permissions in blob storage to allow for brand logos to be displayed */}
            {/* // Remove div below and uncomment the brand.logo ternary when permissions are fixed */}
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-blue-600 font-semibold text-white">
              {brand.name.charAt(0).toUpperCase()}
            </div>
            {/* {brand.logo ? (
              <img className="h-11 w-11 rounded-full" src={brand.logo} alt={brand.name} onError={(e) => {
                  e.currentTarget.style.display = "none";
                }} />
            ) : (
              <span className="h-11 w-11 rounded-full border border-gray-200" />
            )} */}
            <span className="font-bold">{brand.name}</span>
          </div>
          <span className="text-gxe-primary font-bold">- {brand.customerName}</span>
        </div>
        <div className="flex items-center gap-4">
          <Button
            onClick={() => deleteBrand(brand.id, hasActiveTasks)}
            variant="ghost"
            icon={<Trash2 />}
          />
          <Button
            className={cn("group border border-blue-600 bg-white hover:bg-blue-600", {
              "bg-blue-600": expanded,
            })}
            onClick={() => setExpanded((prevState) => !prevState)}
            size="icon_md"
            icon={
              <ChevronDown
                className={cn("h-4 w-4 text-blue-600 transition-all group-hover:text-white", {
                  "rotate-180 text-white": expanded,
                })}
              />
            }
          />
        </div>
      </div>
      <BrandPaths
        // This key forces remounting the component when we delete a brand path, ensuring internal state resets
        key={`${brand.id}-${brand.brandPaths?.length || 0}`}
        brand={brand}
        expanded={expanded}
      />
    </div>
  );
};
